export const uniq = function <T>(items: T[]): T[] {
  if (items.length === 0) {
    return items
  }

  return items.filter((value, index) => items.indexOf(value) === index)
}
